import { render } from "./TheAposNotifications.vue?vue&type=template&id=d47f16b4&scoped=true"
import script from "./TheAposNotifications.vue?vue&type=script&lang=js"
export * from "./TheAposNotifications.vue?vue&type=script&lang=js"

import "./TheAposNotifications.vue?vue&type=style&index=0&id=d47f16b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47f16b4"],['__file',"notification/ui/apos/components/TheAposNotifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d47f16b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d47f16b4', __exports__)) {
    api.reload('d47f16b4', __exports__)
  }
  
  module.hot.accept("./TheAposNotifications.vue?vue&type=template&id=d47f16b4&scoped=true", () => {
    api.rerender('d47f16b4', render)
  })

}


export default __exports__